/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* globals _ */

_.namespace(`Backbone`, function(B) {
  B.Widget = B.TemplateView.extend({
    show() { this.$el.show(); },
    hide() { this.$el.hide(); },
  });
});

}.call(window));